import { motion } from "framer-motion";
import {
  BrainCircuit,
  Scale,
  HeartPulse,
  ShieldCheck,
  Siren,
  Workflow,
} from "lucide-react";
import { Reveal, RevealStagger, staggerItem } from "@/components/site/Reveal";

const DOMAINS = [
  { icon: BrainCircuit, label: "Enterprise AI" },
  { icon: Scale, label: "Legal Technology" },
  { icon: HeartPulse, label: "Healthcare Systems" },
  { icon: ShieldCheck, label: "Insurance Infrastructure" },
  { icon: Siren, label: "Public Safety" },
  { icon: Workflow, label: "Workflow Automation" },
];

export function WhyCogentis() {
  return (
    <section
      className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36"
      data-testid="why-cogentis-section"
    >
      <Reveal>
        <p className="font-mono text-xs text-white/40">06 // WHY COGENTIS</p>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-display mt-8 max-w-4xl text-3xl font-light leading-[1.15] tracking-tight text-white sm:text-5xl">
          Engineering certainty means building systems people can trust when the{" "}
          <span style={{ color: "var(--accent)" }}>stakes are highest.</span>
        </h2>
      </Reveal>

      <RevealStagger className="mt-16 grid grid-cols-2 gap-4 md:grid-cols-3">
        {DOMAINS.map((d) => (
          <motion.div
            key={d.label}
            variants={staggerItem}
            className="group flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.02] p-5 transition-colors duration-300 hover:border-white/25 hover:bg-white/[0.04]"
            data-testid={`domain-${d.label.split(" ")[0].toLowerCase()}`}
          >
            <div
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/10 transition-colors"
              style={{ background: "rgba(255,255,255,0.03)" }}
            >
              <d.icon
                className="h-5 w-5 transition-transform duration-300 group-hover:scale-110"
                style={{ color: "var(--accent)" }}
              />
            </div>
            <span className="font-display text-sm font-medium text-white/85 sm:text-base">
              {d.label}
            </span>
          </motion.div>
        ))}
      </RevealStagger>
    </section>
  );
}
